// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import Button from '../controls/PrimaryButton'

const ElementWrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  padding-top: 10px;
`
const NameLabel: StyledComponent<Object, any, any> = styled.span`
  padding-right: 5px;
  line-height: 30px;
`

type Props = {|
  index: number,
  inputName: string,
  inputValue: string,
  groups: Array<Object>,
  currentGroup: Object,
  onChange: Function,
  onGroupRemove: Function
|}

const t = {
  remove: 'Удалить группу',
  name: 'Название'
}

export default class AddParametersGroupBlock extends Component<Props> {
  render() {
    return (
      <ElementWrapper>
        <NameLabel>{t.name}</NameLabel>
        <input
          name={this.props.inputName}
          type="text"
          className="input-item"
          value={this.props.inputValue}
          onChange={(e) => {
            const newGroups = _.cloneDeep(this.props.groups)
            newGroups[this.props.index].name = e.target.value
            this.props.onChange(newGroups)
          }}
        />
        <Button
          small
          onClick={() => {
            const newGroups = _.without(this.props.groups, this.props.currentGroup)
            this.props.onChange(newGroups)
            this.props.onGroupRemove(newGroups)
          }}
        >
          {t.remove}
        </Button>
      </ElementWrapper>
    )
  }
}
